import { Component } from 'preact'

export default class NewPaybarAccessButtonVacancy extends Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  get accessLink() {
    return this.props.subscription.lastPublishedVacancy?.path
  }

  get buttonText() {
    return I18n.t('newPaybar.successScreen.vacancy.self.access')
  }

  onClick(e) {
    e.preventDefault()

    window.location.href = this.accessLink
  }

  render() {
    return (
      <a
        href={ this.accessLink }
        onClick={ this.onClick }
        className="newPaybarAccessButton button is__enlargedOnMobiles"
        dangerouslySetInnerHTML={{ __html: this.buttonText }} />
    )
  }
}
